import { useState, useLayoutEffect } from 'preact/hooks';
import store from '../../store/store';
import { StoreContext } from '../../contexts/StoreContext';
import ProductComparisonSummary, {
    type ProductComparisonSummaryProps
} from './ProductComparisonSummary';
import { render } from 'preact';

const ProductComparisonSummaryStoreProvider = (
    props: ProductComparisonSummaryProps
) => {
    const [state, setState] = useState(store.getState());
    useLayoutEffect(() => {
        store.subscribe(() => {
            setState(store.getState());
        });
    }, []);
    return (
        <StoreContext.Provider value={state}>
            <div
                className={`bri-App ${window.location.hostname.split('.')[0]}`}
            >
                <ProductComparisonSummary {...props} />
            </div>
        </StoreContext.Provider>
    );
};

export function bootstrap(
    placeholder: HTMLElement,
    productIds: string[],
    title: string
) {
    render(
        <ProductComparisonSummaryStoreProvider
            productIds={productIds}
            title={title}
        />,
        placeholder
    );
}
